import $api from "../../axios"
import { apiAmazonChanges, apiCampaigns } from "../../constants/targetsApi.constants"
import { IChangedTargetBody } from "../../types/target"

const applyOnAmazon = async (data: IChangedTargetBody) => {
  return $api.post(`${apiCampaigns + apiAmazonChanges}/enqueue`, data)
}

export default {
  applyOnAmazon,
}
